"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPlayerBodyToJSON = exports.EditPlayerBodyFromJSONTyped = exports.EditPlayerBodyFromJSON = void 0;
const runtime_1 = require("../runtime");
function EditPlayerBodyFromJSON(json) {
    return EditPlayerBodyFromJSONTyped(json, false);
}
exports.EditPlayerBodyFromJSON = EditPlayerBodyFromJSON;
function EditPlayerBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'playerID': json['playerID'],
        'firstName': !runtime_1.exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !runtime_1.exists(json, 'lastName') ? undefined : json['lastName'],
        'male': !runtime_1.exists(json, 'male') ? undefined : json['male'],
        'handicap': !runtime_1.exists(json, 'handicap') ? undefined : json['handicap'],
        'handicapIndex': !runtime_1.exists(json, 'handicapIndex') ? undefined : json['handicapIndex'],
        'tournamentID': !runtime_1.exists(json, 'tournamentID') ? undefined : json['tournamentID'],
        'teamID': !runtime_1.exists(json, 'teamID') ? undefined : json['teamID'],
        'phoneNumber': !runtime_1.exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'email': !runtime_1.exists(json, 'email') ? undefined : json['email'],
    };
}
exports.EditPlayerBodyFromJSONTyped = EditPlayerBodyFromJSONTyped;
function EditPlayerBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'playerID': value.playerID,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'male': value.male,
        'handicap': value.handicap,
        'handicapIndex': value.handicapIndex,
        'tournamentID': value.tournamentID,
        'teamID': value.teamID,
        'phoneNumber': value.phoneNumber,
        'email': value.email,
    };
}
exports.EditPlayerBodyToJSON = EditPlayerBodyToJSON;
